var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("iframe", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loading,
          expression: "!loading",
        },
      ],
      staticClass: "w-100 h-100",
      attrs: { id: "lesson-exam-embed", src: _vm.src },
      on: { load: _vm.onLoad },
    }),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "loading-screen",
            attrs: { "fill-height": "", "justify-content-center": "" },
          },
          [
            _c("v-progress-circular", {
              staticClass: "loading",
              attrs: { indeterminate: "", color: "green" },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }